/*
 * Copyright © 2025 Gavin Sawyer. All rights reserved.
 */

export const stripePublishableKey: string = "pk_test_51QCNXBPkYnhegMwG95aQaPMDGNAMHl5r812Wnx7is2BxK6ZjGq3dQRWqoPDKv6tNYPGCoamPnMNt2TvPXi0CzGso00FG1mKmUT" as const;
